var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketingAdvertising({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-42892712-42fd-4e03-b427-5c347f1ac84c",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.1,
    height: 66,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.1 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-d0b30d36-a321-49e1-a158-fbb09d6c18d9{fill:url(#uuid-4c5b20ac-91be-4f86-b1f1-81bb7ca5c466);}.uuid-587e25be-576c-471b-b421-df653b9ea08a{fill:url(#uuid-9810a3fc-79e9-4ca7-af72-23fc647057dd);}.uuid-b0df05d9-56fd-4044-9c91-da1a73e105c5{fill:url(#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0);}.uuid-7dbd3677-b967-415a-b8a4-81fd3fcdebb0{fill:url(#uuid-b43b5119-c242-42d0-a1ed-82dad1d03719);}.uuid-2f13d37f-397b-4241-ac8d-70b0cd1ed7d9{fill:url(#uuid-7e6aeeac-2e22-4883-9ec0-70fa310a0fa9);}.uuid-a57d6f20-2864-4039-8f71-6cb2095f56db{fill:url(#uuid-42ad8f5b-160a-4f69-a662-f5e2a6d2f6c9);}.uuid-ad36accd-69d9-4e44-a8ad-79dd9a37bf1a{fill:url(#uuid-a2d257ab-13e1-4963-8007-83d0091aec6b);}.uuid-eecedb4c-0b4d-4a5b-98c3-921561d3e8d5{fill:url(#uuid-a0379018-2b89-4089-94cd-6d4f83b9e3a8);}.uuid-c89462e0-b72a-4662-8035-38cd2b671d60{fill:url(#uuid-0d7185b3-d437-4f6a-9ff2-413416710ada);}.uuid-f24b8d49-90cf-4c36-8c88-c228d3b44f7f{fill:url(#uuid-ce6a17ee-b7ed-4be6-b000-c71ff8449105);}.uuid-27677eba-ad33-4588-801b-bd8055174d7f{fill:url(#uuid-9f712a50-1b39-4043-a41c-8a6d4ca12356);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0",
    x1: 9.7,
    y1: 27.1,
    x2: 53.3,
    y2: 27.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-42ad8f5b-160a-4f69-a662-f5e2a6d2f6c9",
    x1: 36.1,
    y1: 8.2,
    x2: 36.6,
    y2: 8.2,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-0d7185b3-d437-4f6a-9ff2-413416710ada",
    x1: 37.8,
    y1: 15.2,
    x2: 41.2,
    y2: 15.2,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a2d257ab-13e1-4963-8007-83d0091aec6b",
    x1: 35.5,
    y1: 24.3,
    x2: 59.7,
    y2: 24.3,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a0379018-2b89-4089-94cd-6d4f83b9e3a8",
    x1: 0,
    y1: 42.7,
    x2: 14.9,
    y2: 42.7,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-ce6a17ee-b7ed-4be6-b000-c71ff8449105",
    x1: 15.9,
    y1: 56.9,
    x2: 33.4,
    y2: 56.9,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-4c5b20ac-91be-4f86-b1f1-81bb7ca5c466",
    x1: 48.1,
    y1: 22.7,
    x2: 56.1,
    y2: 22.7,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-9810a3fc-79e9-4ca7-af72-23fc647057dd",
    x1: 35.6,
    y1: 7.1,
    x2: 36.1,
    y2: 7.1,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-b43b5119-c242-42d0-a1ed-82dad1d03719",
    x1: 53.3,
    y1: 6.5,
    x2: 61.2,
    y2: 6.5,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7e6aeeac-2e22-4883-9ec0-70fa310a0fa9",
    x1: 60,
    y1: 16.2,
    x2: 72.5,
    y2: 16.2,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-9f712a50-1b39-4043-a41c-8a6d4ca12356",
    x1: 60.8,
    y1: 29.5,
    x2: 74.1,
    y2: 29.5,
    xlinkHref: "#uuid-c4eea792-d15a-4f1f-8eb8-846a9391cbb0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-952b74df-d8ff-4a21-b55d-fac989797cd4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-b0df05d9-56fd-4044-9c91-da1a73e105c5",
    d: "M35.2,8.1l.5,1.1,1.2,2.6,3.4,7.5,1.2,2.6c3.4,7.5,6.7,15,10.1,22.5-.2,0-.4,0-.6-.1-3.9-.9-8-1.5-12-1.6-.6,0-1.1,0-1.7,0-3.6,0-6.9.3-10.2,1-3.2.6-6.1,1.8-9.5,3.3-2.3-5.1-4.4-9.8-6.4-14.4,3.6-1.7,6.8-3.8,9.7-6.3,3.3-2.8,6-5.6,8.2-8.4,2.2-2.7,4.1-5.8,6.2-9.9M35.2,5.7s0,0,0,0c-.2.4-.4.8-.6,1.3-1.8,3.6-3.8,7.1-6.4,10.3-2.4,3-5.2,5.7-8.1,8.3-3.1,2.7-6.4,4.8-10.1,6.5-.2.1-.3.2-.2.5,2.3,5.2,4.7,10.4,7,15.6,0,.2.1.2.2.2s.1,0,.2,0c3.2-1.5,6.5-2.9,9.9-3.6,3.3-.7,6.6-.9,10-.9s1.1,0,1.7,0c4,.1,7.9.6,11.8,1.5.9.2,1.7.4,2.7.6-3.7-8.2-7.3-16.3-10.9-24.5l-1.2-2.6-3.4-7.5-1.2-2.6-.5-1.2c-.2-.3-.3-.7-.4-1h0c-.1-.3-.2-.6-.3-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-a57d6f20-2864-4039-8f71-6cb2095f56db",
    d: "M36.3,8c.2.3.3.5.3.8l-.5-1.2c0,.1.1.3.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c89462e0-b72a-4662-8035-38cd2b671d60",
    d: "M41.2,19l-3.4-7.5s0,0,0,0c1.1,2.5,2.3,5,3.4,7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ad36accd-69d9-4e44-a8ad-79dd9a37bf1a",
    d: "M37.8,1h0c.5,0,.9.3,1.1.8,3.2,7.2,6.5,14.4,9.7,21.6v.3c.1,0,3.3,7,3.3,7,2.2,5,4.4,9.9,6.7,14.9.2.5.2.9,0,1.3-.2.3-.6.5-1,.6,0,0,0,0,0,0-.6,0-1-.5-1.2-.9l-3.5-7.9c-2.1-4.7-4.2-9.4-6.3-14.1-2.8-6.2-5.5-12.4-8.3-18.5l-1.4-3.1c-.3-.7,0-1.4.6-1.7.2,0,.3-.1.5-.1M37.8,0c-.3,0-.6,0-.9.2-1.2.5-1.7,1.8-1.1,3.1,3.2,7.2,6.5,14.4,9.7,21.7,3.3,7.3,6.6,14.7,9.9,22.1.4,1,1.2,1.5,2.1,1.5s0,0,.2,0c1.7-.1,2.6-1.7,1.9-3.3-3.3-7.3-6.5-14.6-9.8-21.9-3.3-7.3-6.5-14.6-9.8-21.9-.4-.9-1.2-1.4-2.1-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-eecedb4c-0b4d-4a5b-98c3-921561d3e8d5",
    d: "M11.4,41.4c1.2,2.6,2.4,5.3,3.5,7.9,0,0,0,.2,0,.3-1.8.8-3.6,1.7-5.4,2.3-2.2.7-4.7-.4-5.7-2.6-1.1-2.5-2.3-5-3.4-7.5-1.1-2.5,0-5.2,2.5-6.4,1.5-.7,2.9-1.3,4.4-2,.3-.1.4-.1.6.2,1.1,2.6,2.3,5.2,3.5,7.7,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-f24b8d49-90cf-4c36-8c88-c228d3b44f7f",
    d: "M15.9,51.3s0,0,.1,0c2.7-1.1,5.3-2.3,8-3.4.3-.1.5,0,.6.2,2.7,3.8,5.3,7.5,8,11.2.4.6.8,1.2.7,2,0,.5-.4,1-.8,1.3-1.3,1-2.6,2-3.9,3-1,.8-2.2.6-3-.4-2.2-3-4.3-6.1-6.5-9.1-1.1-1.5-2.1-3-3.2-4.5,0,0,0,0,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d0b30d36-a321-49e1-a158-fbb09d6c18d9",
    d: "M49.7,17.2c1.5.3,3.5,1.4,4.7,4,1.2,2.6.7,4.9-.1,6.2l-4.6-10.2M49,16.1c-.3,0-.6,0-.9.1,1.9,4.3,3.9,8.7,5.8,13,1.7-1,3.1-4.6,1.4-8.5-1.4-3.2-4.3-4.6-6.4-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-587e25be-576c-471b-b421-df653b9ea08a",
    d: "M36.1,7.6c-.2-.3-.3-.7-.4-1l.4,1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-7dbd3677-b967-415a-b8a4-81fd3fcdebb0",
    x1: 61.2,
    y1: 1,
    x2: 53.3,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-2f13d37f-397b-4241-ac8d-70b0cd1ed7d9",
    x1: 72.5,
    y1: 13.4,
    x2: 60,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-27677eba-ad33-4588-801b-bd8055174d7f",
    x1: 60.8,
    y1: 28.9,
    x2: 74.1,
    y2: 30
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingAdvertising);
export default __webpack_public_path__ + "static/media/Marketing & Advertising.5e3851da2351ff17a2ee5adbed0240de.svg";
export { ForwardRef as ReactComponent };